"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimenums = exports.getTimeStr = exports.addZero = void 0;
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.match");
require("core-js/modules/es6.regexp.to-string");
/**
 * 依据时间获取对应 时间戳
 * @param {string} timeStr // 时间str，格式为 xx:xx
 * @return {number} 如果没格式化成功则返还 0; 成功则返还具体分钟
 */
var getTimenums = exports.getTimenums = function getTimenums(timeStr) {
  var errReturn = undefined;
  var str = timeStr.toString();
  if (!str.match(/^[\d]{1,2}:[\d]{2}$/)) {
    // 不符合
    // throw new Error('传入的时间不符合格式xx:xx')
    console.log('传入的时间不符合格式xx:xx');
    return errReturn;
  } else {
    // 符合xx:xx格式
    var timeArr = str.split(':');
    var hour = Number(timeArr[0]);
    var minite = Number(timeArr[1]);
    if (hour <= 23 && minite < 60 || hour === 24 && minite === 0) {
      // 符合时间格式
      return hour * 60 + minite;
    } else {
      // 不是时间数据
      console.log('传入的str不是时间');
      return errReturn;
    }
  }
};

/**
 * 加0
 * @param {*} num //
 * @returns
 */
var addZero = exports.addZero = function addZero(num) {
  var str = num.toString();
  if (str.length === 1) {
    return "0".concat(str);
  } else {
    return str;
  }
};

/**
 * 依据时间戳获取对应time str
 */
var getTimeStr = exports.getTimeStr = function getTimeStr(timeNum) {
  var hour = Math.floor(timeNum / 60);
  var minite = timeNum % 60;
  return "".concat(addZero(hour), ":").concat(addZero(minite));
};